var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.34783 4.28571V2H4.91304V4.28571H7.26087V5.80952H4.91304V8.09524H3.34783V5.80952H1V4.28571H3.34783ZM5.69565 8.85714V6.57143H8.04348V4.28571H13.5217L14.9539 5.80952H17.4348C18.2957 5.80952 19 6.49524 19 7.33333V16.4762C19 17.3143 18.2957 18 17.4348 18H4.91304C4.05217 18 3.34783 17.3143 3.34783 16.4762V8.85714H5.69565ZM11.1739 15.7143C13.3339 15.7143 15.087 14.0076 15.087 11.9048C15.087 9.8019 13.3339 8.09524 11.1739 8.09524C9.01391 8.09524 7.26087 9.8019 7.26087 11.9048C7.26087 14.0076 9.01391 15.7143 11.1739 15.7143ZM8.66957 11.9048C8.66957 13.2533 9.7887 14.3429 11.1739 14.3429C12.5591 14.3429 13.6783 13.2533 13.6783 11.9048C13.6783 10.5562 12.5591 9.46667 11.1739 9.46667C9.7887 9.46667 8.66957 10.5562 8.66957 11.9048Z",
    fill: "#2F54EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.dbc95828f19e82fd666427ebe68db362.svg";
export { ForwardRef as ReactComponent };